// Función para obtener la ruta base dinámicamente
const getBasePath = (): string => {
  if (process.env.NODE_ENV === 'development') {
    return '';
  }
  
  // Detectar la ruta base desde la URL actual
  const pathname = window.location.pathname;
  
  // Si está en /portal/web_tarot/samael, usar esa ruta base
  if (pathname.includes('/portal/web_tarot/samael')) {
    return '/portal/web_tarot/samael';
  }
  
  // Si está en /samael, usar esa ruta base
  if (pathname.includes('/samael')) {
    return '/samael';
  }
  
  // Por defecto, usar la ruta base vacía
  return '';
};

// Función para obtener la URL de la API dinámicamente
const getApiUrl = (): string => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  
  if (process.env.NODE_ENV === 'production') {
    // En producción, usar el mismo origen
    return window.location.origin;
  }
  
  return 'http://localhost:3000';
};

// Función para obtener la URL de inicio dinámicamente
const getHomeUrl = (): string => {
  // Siempre usar la variable de entorno si está configurada, o por defecto mystictarot.co
  if (process.env.REACT_APP_HOME_URL) {
    return process.env.REACT_APP_HOME_URL;
  }
  
  // Siempre retornar mystictarot.co sin importar desde dónde se acceda
  return 'https://mystictarot.co/';
};

export const config = {
  API_URL: getApiUrl(),
  WS_URL: process.env.REACT_APP_WS_URL || (process.env.NODE_ENV === 'production' ? window.location.origin.replace('http://', 'ws://').replace('https://', 'wss://') : 'ws://localhost:3000'),
  HOME_URL: getHomeUrl(),
  BASE_PATH: getBasePath(),
  PUBLIC_URL: getBasePath() || process.env.PUBLIC_URL || '',
};
